var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigninInprogress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.641,
    height: 36.001,
    viewBox: "0 0 31.641 36.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signin_inprogress",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(37.614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8537",
    "data-name": "Path 8537",
    d: "M130.206,0a9.206,9.206,0,1,0,9.206,9.206A9.206,9.206,0,0,0,130.206,0Z",
    transform: "translate(-121)",
    fill: "#dc3a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(31 21.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8538",
    "data-name": "Path 8538",
    d: "M58.63,303.969A13.742,13.742,0,0,0,48.93,300H44.711a13.742,13.742,0,0,0-9.7,3.969A13.213,13.213,0,0,0,31,313.435a1.039,1.039,0,0,0,1.055,1.023H61.586a1.039,1.039,0,0,0,1.055-1.023,13.213,13.213,0,0,0-4.011-9.466Z",
    transform: "translate(-31 -300)",
    fill: "#dc3a1a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninInprogress);
export default __webpack_public_path__ + "static/media/signin_inprogress.1a1943816586a5f8fff261620a9e5e10.svg";
export { ForwardRef as ReactComponent };